import * as actions from './actions'
import * as constants from './constants'
import reducer from './reducer'

export default { actions, constants, reducer }
